import {FileDiffIcon} from '@primer/octicons-react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ActionBarTrigger} from './ActionBarTrigger'
import styles from './AhpTaskChatInputActionBar.module.css'

export interface DiffTriggerButtonProps {
  additions: number
  deletions: number
  onViewDiff?: () => void
}

export function DiffTriggerButton({additions, deletions, onViewDiff}: DiffTriggerButtonProps) {
  return (
    <ActionBarTrigger
      onClick={() => onViewDiff?.()}
      disabled={!onViewDiff}
      leadingVisual={isFeatureEnabled('copilot_mission_control_ahp_diff_workbench') ? FileDiffIcon : undefined}
    >
      Changes <span className={styles.DiffAddition}>+{additions}</span>{' '}
      <span className={styles.DiffDeletion}>-{deletions}</span>
    </ActionBarTrigger>
  )
}

DiffTriggerButton.displayName = 'DiffTriggerButton'
